import ApplicationHeaderContainer from './container';

export default ApplicationHeaderContainer;
